import React from "react";
import Card from "../components/Card";
import './Pitch.css';
import { TargetMarketChart, RetailMarketGrowthChart, ECommerceGrowthChart, TargetRetailersChart , SalesTeamExpansionChart, BudgetChart, EstimatedLossChart, FinancialProjections} from "../components/Charts";

import partnerShipImage from '../assets/images/pitch/HandShake1.png';
import fragmentationImage from '../assets/images/pitch/Fragmentation1.png';
import inventoryManagementImage from '../assets/images/pitch/Inventory_Management1.png';
import digitalAdoptionImage from '../assets/images/pitch/LackOfDigitalAdoption.png';
import customerExperienceImage from '../assets/images/pitch/poorCustomerExperience.png';

import financialImpactImage from '../assets/images/pitch/FinancialImpact/impact.jpg';
import financialStakeImage from '../assets/images/pitch/FinancialImpact/Stake.jpg';
import logo from '../assets/Logo/Logo.png';

import RetailMarketSituationImage from '../assets/images/pitch/Problem/RetailMarketSituation.png';
import EmpowermentImage from '../assets/images/pitch/Solution/Empowerment.png';
import SeamlessImage from '../assets/images/pitch/Solution/Seamless.png';
import AffordableImage from '../assets/images/pitch/Solution/Affordable.png';
import LocationImage from '../assets/images/pitch/Solution/Location.png';

const Pitch = () => {
  return (
    <div className="pitch-page">
      <h1>Our Pitch</h1>

      <section className="card-section">
        <Card
          heading="Mission"
          body={
            <p className="special-text">
              We aim to provide small and medium-sized retailers with user-friendly mobile-based Point of Sale (PoS) systems.
              <br />
              <br />
              Our platform will enable seamless connections with both walk-in and online customers, revolutionizing the way local businesses operate and compete.
            </p>
          }
        />
      </section>

      <section className="card-section">
        <Card
          heading="Market Opportunity"
          body={
            <div className="charts-container">
              <div className="chart-item">
                <h3 className="chart-heading">Target Market</h3>
                <TargetMarketChart />
                <p>We aim to capture 1% of India's 13M retail stores in 5 years and 5% in 10 years.</p>
              </div>
              <div className="chart-item">
                <h3 className="chart-heading">Retail Market Growth</h3>
                <RetailMarketGrowthChart />
                <p>Retail market is expected to grow from $883 billion in 2020 to $1.3 trillion by 2025.</p>
              </div>
              <div className="chart-item">
                <h3 className="chart-heading">eCommerce Growth</h3>
                <ECommerceGrowthChart />
                <p>eCommerce is projected to grow at a CAGR of 27%, reaching $111 billion by 2024.</p>
              </div>
            </div>
          }
        />
      </section>

      <section className="card-section">
        <Card
          heading="The Problem"
          body={

            <div className="charts-container">
              <div className="chart-item">
                <h3 className="chart-heading">The Battle for Market Share</h3>
                <img
                  src= {RetailMarketSituationImage}
                  alt="Partnership Strategy"
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "10px",
                  }}
                />
                <p>Losing market share to the larger eCommerce players.</p>
              </div>
              <div>
                <p className="special-text">
                  Local merchants are facing unprecedented challenges due to the rapid rise of eCommerce.
                  <br />
                  <br />
                  Since 2000, local retailers have been under immense pressure, with many unable to adapt to the digital marketplace.
                </p>
              </div>
            </div>
            
          }
        />
      </section>

      <section className="card-section">
        <Card
          heading="Challenges : Current Retail & eCommerce Environment"
          body={
            <div className="charts-container">
              <div className="chart-item">
                <h3 className="chart-heading">Fragmentation</h3>
                <img
                  src= {fragmentationImage}
                  alt="Partnership Strategy"
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "10px",
                  }}
                />
                <p>Small, unorganized retailers struggle to compete with larger eCommerce players.</p>
              </div>
              <div className="chart-item">
                <h3 className="chart-heading">Inventory Management</h3>
                <img
                  src= {inventoryManagementImage}
                  alt="Partnership Strategy"
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "10px",
                  }}
                />
                <p>Many retailers face issues with manual inventory management, affecting profitability.</p>
              </div>
              <div className="chart-item">
                <h3 className="chart-heading">Digital Adoption</h3>
                <img
                  src= {digitalAdoptionImage}
                  alt="Partnership Strategy"
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "10px",
                  }}
                />
                <p>Small retailers often lack the resources to adopt technology effectively.</p>
              </div>
              <div className="chart-item">
                <h3 className="chart-heading">Customer Experience</h3>
                <img
                  src= {customerExperienceImage}
                  alt="Partnership Strategy"
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "10px",
                  }}
                />
                <p>Traditional stores often fail to provide a seamless omnichannel experience.</p>
              </div>
            </div>
          }
        />
      </section>

      <section className="card-section">
        <Card
          heading="Estimation of Losses"
          body={
            <div className="charts-container">
              <div className="chart-item">
                <h3 className="chart-heading">Estimated Loss</h3>
                <EstimatedLossChart />
                {/*<p>We aim to capture 1% of India's 13M retail stores in 5 years and 5% in 10 years.</p>*/}
              </div>
              <div className="chart-item">
                <h3 className="chart-heading">Current Estimated Loss</h3>
                <p>Local merchants could be losing up to 40% of potential sales due to a lack of online presence.</p>
              </div>
              <div className="chart-item">
                <h3 className="chart-heading">Future Severity</h3>
                <p>This loss could increase to 60% over the next decade as eCommerce continues to expand.</p>
              </div>
            </div>
          }
        />
      </section>

      <section className="card-section">
        <Card
          heading="Financial Impact"
          body={
            <div className="charts-container">
              <div className="chart-item">
                <h3 className="chart-heading">Impact</h3>
                <img
                  src= {financialImpactImage}
                  alt="Partnership Strategy"
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "10px",
                  }}
                />
                <p>The estimated revenue loss from local merchants due to increased eCommerce activity is around ₹1 trillion from 2000 to 2024.</p>
              </div>
              <div className="chart-item">
                <h3 className="chart-heading">Stakes</h3>
                <img
                  src= {financialStakeImage}
                  alt="Partnership Strategy"
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "10px",
                  }}
                />
                <p>
                  
                <br />
                <br />
                The stakes are high, and the future of local commerce hangs in the balance. 
                <br />
                <br />
                <br />
                </p>
              </div>
              <div className="chart-item">
                <h3 className="chart-heading">Solutions</h3>
                <img
                  src= {logo}
                  alt="Partnership Strategy"
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "10px",
                  }}
                />
                
                <br />
                <br />
                <br />
                <p>Without solutions like Quipo, these businesses risk extinction, along with the invaluable community connections they support. 
                <br />
                <br />
                </p>
              </div>
            </div>
          }
        />
      </section>

      <section className="card-section">
        <Card
          heading="Our Solution: Mobile-Based PoS System"
          body={
            <div className="charts-container">
              <div className="chart-item">
                <h3 className="chart-heading">Empowerment</h3>
                <img
                  src= {EmpowermentImage}
                  alt="Partnership Strategy"
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "10px",
                  }}
                />
                <p>
                  
                <br />
                Empowering Small and Medium-Sized Retailers: <br />
                  <br />
                  Affordable, easy-to-use mobile-based solution. <br />
                  <br />
                  Track inventory in real-time.
                </p>
              </div>
              <div className="chart-item">
                <h3 className="chart-heading">Seamless</h3>
                <img
                  src= {SeamlessImage}
                  alt="Partnership Strategy"
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "10px",
                  }}
                />
                <p>Seamless Integration of Transactions: <br />
                  <br />
                  Integrate walk-in and online customers into one system.<br />
                  <br />
                  Offer a real-time view of inventory, enabling online shoppers to know product availability.
                  </p>
              </div>
              <div className="chart-item">
                <h3 className="chart-heading">Affordable </h3>
                <img
                  src= {AffordableImage}
                  alt="Partnership Strategy"
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "10px",
                  }}
                />
                <p> 
                <br />
                
                <br />
                  Affordable Technology for Rural and Urban Markets:<br />
                  <br />
                  Works offline and online. <br />
                  <br />
                  <br />
                </p>
              </div>
              <div className="chart-item">
                <h3 className="chart-heading">Location </h3>
                <img
                  src= {LocationImage}
                  alt="Partnership Strategy"
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "10px",
                  }}
                />
                <p>
                  
                <br />
                Benefits for the merchants:<br />
                  <br />
                  Expand Market Reach: <br />
                  <br />
                  Optimize Business Operations.<br />
                  <br />
                  Enhance Customer Experience.
                </p>
              </div>
            </div>
          }
        />
      </section>

      <section className="card-section">
        <Card
          heading="Financial Projections"
          body={
            <FinancialProjections />
          }
        />
      </section>

      <section className="card-section">
        <Card
          heading="Go-To-Market Strategy"
          body={
            <div className="charts-container">
              <div className="chart-item">
                <h3 className="chart-heading">Targeting Unorganized Retailers</h3>
                <TargetRetailersChart />
                <p>Focus on the 88% of the retail sector that is unorganized.</p>
              </div>
              <div className="chart-item">
                <h3 className="chart-heading">Sales Team Expansion </h3>
                <SalesTeamExpansionChart />
                <p>Gradually add new sales executives to reach more merchants.</p>
              </div>
              <div className="chart-item">
                <h3 className="chart-heading">Partnerships</h3>
                <img
                  src= {partnerShipImage}
                  alt="Partnership Strategy"
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "10px",
                  }}
                />
                <p>Collaborate with local business associations to facilitate onboarding.</p>
              </div>
            </div>
          }
        />
      </section>

      <section className="card-section">
        <Card
          heading="Long-Term Vision:"
          body={
            <p className="special-text">
              By prioritizing eCommerce, we position ourselves to scale rapidly and reach a diverse audience.
            </p>
          }
        />
      </section>

      <section className="card-section">
        <Card
          heading="Use Of Funds"
          body={
            <BudgetChart />
          }
        />
      </section>

      <section className="card-section">
        <Card
          heading="Conclusion"
          body={
            <p className="special-text">
              Quipo Software Pvt. Ltd. is not merely a startup; it is a movement aimed at empowering local businesses and transforming commerce as we know it. <br />
              <br />
              With our revolutionary PoS system and a strong emphasis on eCommerce, we are set to lead the future of local commerce.
            </p>
          }
        />
      </section>

      <section className="card-section">
        <Card
          heading="Join Us"
          body={
            <p className="special-text">
              Join us in our journey to create a more connected, prosperous, and resilient community.
            </p>
          }
        />
      </section>

      
    </div>
  );
};

export default Pitch;